import { LockOpen } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { dataBR, hora, reais } from "../lib/caixa";

/** Nenhum caixa aberto: o convite para abrir e como terminou o último. */
export default function CaixaFechado({ ultimo, onAbrir, podeAbrir = true, onVerUltimo }) {
  return (
    <div className="rounded-2xl border bg-card p-6 sm:p-8 text-center" data-e2e="caixa-fechado">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto"><LockOpen className="w-7 h-7" /></div>
      <h2 className="text-xl font-bold mt-3">Caixa fechado</h2>
      <p className="text-sm text-muted-foreground mt-1">Abra o caixa para começar a vender. Informe o dinheiro de troco que está na gaveta.</p>
      {podeAbrir
        ? <Button onClick={onAbrir} className="mt-4 h-12 px-8 text-base font-semibold" data-e2e="abrir-caixa">Abrir caixa</Button>
        : <p className="mt-4 text-sm font-medium text-muted-foreground" data-e2e="abrir-caixa-bloqueado">Você não tem permissão para abrir o caixa — o dono libera em Pessoas › Funcionários.</p>}
      {ultimo && (
        <p className="text-xs text-muted-foreground mt-4">
          Último: #{ultimo.id} de {dataBR(ultimo.opened_at)}, fechado às {hora(ultimo.closed_at)} por {ultimo.fechado_por || ultimo.usuario_nome} — contado {reais(ultimo.valor_fechamento_real)}
          {onVerUltimo && <> · <button type="button" onClick={() => onVerUltimo(ultimo)} className="text-primary font-medium hover:underline" data-e2e="ver-ultimo-fechamento">Ver fechamento</button></>}
        </p>
      )}
    </div>
  );
}
